import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';
import PersonIcon from '@mui/icons-material/Person';
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import BlankContent from '../common/BlankContent';
import PatientCard from './PatientCard';
import PatientTableRow from './PatientTableRow';
import CustomPagination from "../common/CustomPagination";

const PatientTable = props => {
  const navigate = useNavigate();
  return (
    <Box>
        <TableContainer sx={{ width: '100%', display: {xs: 'none', sm: 'block'}, padding:'19px 0 0 0'}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" sx={{width: '10%'}}>Status</TableCell>
                <TableCell align="left">Name</TableCell>
                <TableCell align="left">DOB (Age)</TableCell>
                <TableCell align="center">Sessions</TableCell>
                <TableCell align="left">Last Seen</TableCell>
                <TableCell align="left">Lead Source</TableCell>
                <TableCell align="left">Note</TableCell>
                <TableCell align='left'>Cases</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.rows || []).map(row =>
                <PatientTableRow {...row} reload={props.reload}/>
              )}
            </TableBody>
          </Table>
          {
            !props.rows || !props.rows.length
            ? <BlankContent
              title='No patients found'
              Icon={PersonIcon}
            />
            : null
          }
          <Box style={{marginTop: '1em'}}>
            {props.rows && props.rows.length
              ?
              <CustomPagination {...props}/>
              : null
            }
          </Box>
        </TableContainer>
      <Box sx={{display: {'xs': 'block', 'sm': 'none', 'md': 'none', 'lg': 'none'}}}>
        <Stack spacing={1} padding={1}>
          {(props.rows|| []).map(row =>
            <PatientCard patient={row.data} reload={props.reload}/>
          )}
        </Stack>
        <Box style={{marginTop: '1em'}}>
          { props.rows && props.rows.length
            ? <CustomPagination {...props}/>
            : null
          }
        </Box>
        {
          !props.rows || !props.rows.length
          ? <BlankContent
            title='No patients found'
            Icon={SportsKabaddiIcon}
          />
          : null
        }
      </Box>
    </Box>
  );
};

PatientTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object, // the row data
    buttons: PropTypes.arrayOf(PropTypes.element), // buttons for the row
  })),
  count: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
};

export default PatientTable;
